import React from 'react'
import moment from 'moment'

import { PageXY } from 'src/views/Management/Reports/types'

import { WrapFooter } from './style'

interface Props
  extends Readonly<{
    pagination: PageXY
  }> {}

function Footer({ pagination: { x, y } }: Props) {
  const today = moment().format('DD/MM/YYYY HH:mm')
  return (
    <WrapFooter>
      <div>{today}</div>
      <div>{`${x} ${' - '} ${y}`}</div>
    </WrapFooter>
  )
}

export default Footer
